/**
 * Download Button with Progress States
 * Handles file downloads with fetch API and fallback
 */

export function initDownloadButtons() {
  const selector = '[data-download-src]';
  const attrSrc = 'data-download-src';
  const attrName = 'data-download-name';

  const setState = (el, state) => {
    el.dataset.downloadState = state; // "idle" | "downloading" | "ready" | "fallback"
  };

  const triggerDownload = (url, filename) => {
    const a = document.createElement('a');
    a.href = url;
    if (filename) a.download = filename;
    a.rel = 'noopener';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  document.querySelectorAll(selector).forEach(el => {
    setState(el, 'idle');

    // Optional label inside the button
    const labelEl = el.querySelector('[data-download-label]');
    if (labelEl && !labelEl.dataset.downloadOriginalLabel) {
      labelEl.dataset.downloadOriginalLabel = labelEl.textContent;
    }

    const showSuccessAndReset = () => {
      if (labelEl) {
        const successText = labelEl.getAttribute('data-download-success');
        if (successText) {
          labelEl.textContent = successText;
        }
      }

      // clear any previous timer on this button
      if (el._downloadResetTimeout) {
        clearTimeout(el._downloadResetTimeout);
      }

      el._downloadResetTimeout = setTimeout(() => {
        setState(el, 'idle');

        if (labelEl) {
          const original = labelEl.dataset.downloadOriginalLabel;
          if (original != null) {
            labelEl.textContent = original;
          }
        }
      }, 3000);
    };

    el.addEventListener('click', async (e) => {
      e.preventDefault();
      console.log('[Download Button] Click detected', { src: el.getAttribute(attrSrc), state: el.dataset.downloadState });

      // prevent double-click spam while we're fetching
      if (el.dataset.downloadState === 'downloading') {
        console.log('[Download Button] Already downloading, ignoring click');
        return;
      }

      const src = el.getAttribute(attrSrc);
      if (!src) {
        console.warn('[Download Button] No download source found... aborting');
        return;
      }

      const customName = el.getAttribute(attrName);

      // derive filename from URL if no explicit name
      const urlObj = new URL(src, window.location.href);
      const urlFilePart = urlObj.pathname.split('/').pop() || 'download';

      const fileName = customName || urlFilePart;
      console.log('[Download Button] Starting download', { src, fileName });

      // remove focus from the button we clicked
      el.blur();

      try {
        setState(el, 'downloading');
        console.log('[Download Button] State: downloading');

        const res = await fetch(src, { mode: 'cors', credentials: 'omit' });
        console.log('[Download Button] Fetch response', { status: res.status, ok: res.ok });
        
        if (!res.ok) throw new Error('bad status');

        const blob = await res.blob();
        console.log('[Download Button] Blob created', { size: blob.size, type: blob.type });
        
        const objectUrl = URL.createObjectURL(blob);

        setState(el, 'ready');
        console.log('[Download Button] State: ready, triggering download');
        triggerDownload(objectUrl, fileName);
        showSuccessAndReset();

        // cleanup a bit later
        setTimeout(() => URL.revokeObjectURL(objectUrl), 10_000);
      } catch (err) {
        // CORS / network / whatever → fallback to plain link
        console.warn('[Download Button] Fetch failed, using fallback', err);
        setState(el, 'fallback');
        triggerDownload(src, fileName);
        showSuccessAndReset();
      }
    });
  });
}